import { render, staticRenderFns } from "./InviteParent.pug?vue&type=template&id=792556a2&scoped=true&lang=pug&"
import script from "./InviteParent.vue?vue&type=script&lang=js&"
export * from "./InviteParent.vue?vue&type=script&lang=js&"
import style0 from "./InviteParent.scss?vue&type=style&index=0&id=792556a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792556a2",
  null
  
)

export default component.exports